package com.essntl.features.paymentparameter.ui.paymentparameter.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterEvent
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterNavigation
import com.essntl.features.paymentparameter.ui.paymentparameter.PaymentParameterState
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun PaymentParameterItem(
    paymentParameter: PaymentParameterModel,
    state: PaymentParameterState,
    onEvent: (PaymentParameterEvent) -> Unit,
    onNavigation: (PaymentParameterNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isDropDownExpanded by remember { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(RoundedCornerShape(16.dp))
            .background(color = MaterialTheme.esColorScheme.bgPrimary)
            .padding(1.5f.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.5f.spacing),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
            ) {
                Text(
                    text = paymentParameter.name ?: "",
                    style = MaterialTheme.esTypography.p1Medium16,
                )

                Text(
                    text = "${
                        if (paymentParameter.method == PaymentParameterModel.Method.Add)
                            "Adding to" else "Substracting from"
                    } amount",
                    style = MaterialTheme.esTypography.p2Regular14.copy(
                        color = MaterialTheme.esColorScheme.textSecondary,
                    ),
                )
            }
        }

        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(1.spacing),
        ) {
            Text(
                text = (if (paymentParameter.type == PaymentParameterModel.Type.FlatFee) "$" else "") +
                    formatIntMoney(paymentParameter.amount ?: 0) +
                    (if (paymentParameter.type == PaymentParameterModel.Type.Percentage) "%" else ""),
                style = MaterialTheme.esTypography.p1Medium16,
            )

            Box {
                if (state.deleteLoading.contains(paymentParameter.id))
                    EsSpinner()
                else {
                    EsLargeIcon(
                        res = EsIcons.MoreVertical,
                        tint = LocalContentColor.current,
                        modifier = Modifier
                            .clip(CircleShape)
                            .pointerHoverIcon(PointerIcon.Hand)
                            .clickable {
                                isDropDownExpanded = true
                            },
                    )

                    EsDropDownMenu(
                        expanded = isDropDownExpanded,
                        onDismissRequest = { isDropDownExpanded = false },
                        modifier = Modifier
                            .width(187.dp),
                    ) {
                        EsDropdownMenuItem(
                            text = "Edit",
                            prefixIcon = EsIcons.Edit,
                            iconColor = MaterialTheme.esColorScheme.iconPrimary,
                            onClick = {
                                isDropDownExpanded = false
                                onNavigation(PaymentParameterNavigation.EditPaymentParameter(paymentParameter))
                            },
                            modifier = Modifier.height(40.dp),
                        )

                        EsDropdownMenuItem(
                            text = "Delete",
                            textColor = MaterialTheme.esColorScheme.textError,
                            prefixIcon = EsIcons.Trash,
                            iconColor = MaterialTheme.esColorScheme.iconError,
                            onClick = {
                                isDropDownExpanded = false
                                onEvent(PaymentParameterEvent.DeletePaymentParameter(paymentParameter))
                            },
                            modifier = Modifier.height(40.dp),
                        )
                    }
                }
            }
        }
    }
}